import React, { FunctionComponent, useEffect, useRef } from 'react'
import './e3dSharingDashboard.css'

type Props = {
  onClose?: () => void
}

const E3DSharingDashboard: FunctionComponent<Props> = ({ onClose }) => {
  const dashboardRef = useRef<any>(null)

  useEffect(() => {
    const dashboardElement = dashboardRef.current
    if (!dashboardElement || !onClose) {return}

    const handleClose = () => {
      onClose()
    }

    dashboardElement.addEventListener('closed', handleClose)

    return () => {
      dashboardElement.removeEventListener('closed', handleClose)
    }
  }, [onClose])

  return <e3d-sharing-dashboard ref={dashboardRef} />
}

export default E3DSharingDashboard
